var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.3335 4.83333H14.6668M6.3335 8.16667V13.1667M9.66683 8.16667V13.1667M2.16683 4.83333L3.00016 14.8333C3.00016 15.2754 3.17576 15.6993 3.48832 16.0118C3.80088 16.3244 4.2248 16.5 4.66683 16.5H11.3335C11.7755 16.5 12.1994 16.3244 12.512 16.0118C12.8246 15.6993 13.0002 15.2754 13.0002 14.8333L13.8335 4.83333M5.50016 4.83333V2.33333C5.50016 2.11232 5.58796 1.90036 5.74424 1.74408C5.90052 1.5878 6.11248 1.5 6.3335 1.5H9.66683C9.88784 1.5 10.0998 1.5878 10.2561 1.74408C10.4124 1.90036 10.5002 2.11232 10.5002 2.33333V4.83333",
    stroke: "#F90808",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.555bc6d652a8b1c13df01f2cf5920f80.svg";
export { ForwardRef as ReactComponent };